// modules
import Cookies from 'js-cookie'
import { handleActions } from 'redux-actions'

// actions
import {
  deleteUserData,
  setIsManuallyLoggedOut,
  setIsUserAuthorized,
  setUserGridSettings,
  setUserProfile
} from 'src/store/modules/auth/actionCreators'

const initialState = {
  profile: {},
  isManuallyLoggedOut: false,
  isUserAuthorized: Boolean(
    Cookies.get('access_token') || Cookies.get('refresh_token')
  )
}

export default handleActions(
  {
    [`${setUserProfile}`](state: any, { payload: profile }: any) {
      return {
        ...state,
        profile
      }
    },

    [`${setUserGridSettings}`](state: any, { payload }: any) {
      return {
        ...state,
        profile: {
          ...state.profile,
          gridSettings: payload
        }
      }
    },

    [`${setIsUserAuthorized}`](state: any, { payload: isUserAuthorized }: any) {
      return {
        ...state,
        isUserAuthorized
      }
    },

    [`${setIsManuallyLoggedOut}`](
      state: any,
      { payload: isManuallyLoggedOut }: any
    ) {
      return {
        ...state,
        isManuallyLoggedOut
      }
    },

    [`${deleteUserData}`]() {
      return initialState
    }
  },
  initialState
)
